import {
  fetchResource,
} from './index'

import { deviceSchema } from '../schemas'

export const DEVICE_REQUEST = 'DEVICE_REQUEST'
export const DEVICE_SUCCESS = 'DEVICE_SUCCESS'
export const DEVICE_FAILURE = 'DEVICE_FAILURE'

export function fetchDevice() {
  return fetchResource({
    url: '/users/device',
    key: 'device',
    schema: deviceSchema,
    actions: [ DEVICE_REQUEST, DEVICE_SUCCESS, DEVICE_FAILURE ],
  })
}




// WEBPACK FOOTER //
// ./src/actions/device.js